import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=7b985944&scoped=true&"
import script from "./SideDrawer.vue?vue&type=script&lang=js&"
export * from "./SideDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=7b985944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b985944",
  null
  
)

export default component.exports